import React, { useState, useEffect } from 'react';
import { accountApi, salesApi } from '../../api';
import { PageHeader, StatCard } from '../../components/common';

const DeveloperDashboard = () => {
  const [accountStats, setAccountStats] = useState(null);
  const [salesStats, setSalesStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [accRes, salesRes] = await Promise.all([
          accountApi.getStatistics(),
          salesApi.getStatistics()
        ]);
        setAccountStats(accRes.data);
        setSalesStats(salesRes.data);
      } catch (err) {
        console.error('Failed to fetch stats:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  return (
    <div>
      <PageHeader title="开发者仪表盘" />

      <h3 style={{ marginBottom: '15px' }}>我的账号统计</h3>
      <div className="stats-grid">
        <StatCard title="总账号数" value={accountStats?.total || 0} color="#1890ff" />
        <StatCard title="可用账号" value={accountStats?.available || 0} color="#52c41a" />
        <StatCard title="已售账号" value={accountStats?.sold || 0} color="#faad14" />
        <StatCard title="已禁用" value={accountStats?.disabled || 0} color="#ff4d4f" />
      </div>

      <h3 style={{ marginBottom: '15px' }}>关联销售统计</h3>
      <div className="stats-grid">
        <StatCard title="关联销售记录" value={salesStats?.total || 0} color="#1890ff" />
        <StatCard title="已发号" value={salesStats?.delivered || 0} color="#52c41a" />
        <StatCard title="已结算" value={salesStats?.settled || 0} color="#722ed1" />
        <StatCard title="总金额" value={`¥${(salesStats?.total_amount || 0).toFixed(2)}`} color="#faad14" />
      </div>
    </div>
  );
};

export default DeveloperDashboard;
